import { useEffect } from "react";
import { SiteSettingsKeys } from "models/dto/ZoomiLxp/Utilities/Constants/SiteSettingsKeys";
import { useAppStore } from "store";
import { ISaveEventCourseItemHistoryModel } from "models/dto/ZoomiLxp/Models/EventModels/ISaveEventCourseItemHistoryModel";
import { EventTypes } from "models/dto/ZoomiLxp/Utilities/Enumerations/EventTypes";
import { ICourseItemNavigation } from "models/dto/ZoomiLxp/Models/Courses/ICourseItemNavigation";

export const useSendEventsBatch = (disableInterval?: boolean) => {
	const { settingsStore, contentStore, coursesStore } = useAppStore();
	const pagesSettings = settingsStore.publicSettings.Pages;
	const batchSize: number = Number(pagesSettings?.[SiteSettingsKeys.MyDeskSendEventsBatchSize]);
	const sendInterval: number = Number(pagesSettings?.[SiteSettingsKeys.MyDeskSendEventsInterval]) * 1000;

	const eventsBatchHandler = (event: ISaveEventCourseItemHistoryModel) =>
		new Promise<void>((resolve, reject) => {
			const eventTime = Date.now();
			// Recorded now, because the batch may not be flushed until after the learner has
			// moved to another course item and the store's live session belongs to that one.
			const courseItemId = coursesStore.curActiveContent?.courseItemId ?? 0;
			const updatedEvent = { event, eventTime, courseItemId };
			contentStore.eventsBatch = [...contentStore.eventsBatch, updatedEvent];

			//bold solution for last content fast get back
			if (event.payload) {
				const tempPayload = JSON.parse(event.payload);
				let tempLastWatched: ICourseItemNavigation = { id: coursesStore.curActiveContent?.courseItemId ?? 0 };
				if (tempPayload.posX) {
					tempLastWatched = { ...tempLastWatched, posX: tempPayload.posX };
				}
				if (tempPayload.posY) {
					tempLastWatched = { ...tempLastWatched, posY: tempPayload.posY };
				}
				if (tempPayload.newPosition) {
					tempLastWatched = { ...tempLastWatched, position: tempPayload.newPosition };
				} else if (tempPayload.currentPosition) {
					tempLastWatched = { ...tempLastWatched, position: tempPayload.currentPosition };
				}


				if (tempLastWatched.posX || tempLastWatched.posY || tempLastWatched.position) {
					coursesStore.tempLastWatchedCourseItem = tempLastWatched;
				}
			}


			if (event.eventType === EventTypes.Complete) {
				coursesStore.updateActiveCourseItemToCompleted();
			}
			if (
				contentStore.eventsBatch.length >= batchSize ||
				event.eventType === EventTypes.End ||
				event.eventType === EventTypes.Complete
			) {
				contentStore.sendCourseItemEventsBatch(contentStore.eventsBatch).catch((err) => reject(err));
				contentStore.eventsBatch = [];
			}
			resolve();
		});

	useEffect(() => {
		if (contentStore.sessionId && !disableInterval) {
			contentStore.startBatchInterval(sendInterval);
		}
	}, [contentStore, contentStore.sessionId, sendInterval, disableInterval]);

	useEffect(
		() => {
			return () => {
				setTimeout(() => {
					contentStore.stopBatchInterval();
				}, 1000);
			};
		}, //eslint-disable-next-line
		[]
	);

	return { eventsBatchHandler };
};
